import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Map } from 'services/action';

import Maps from 'ui/components/mapbox/map.manifest.create';
import { Skeletons } from 'ui/components/skeleton';
import { currencyFormat } from 'utilities/common';

export const FormMap = ({ type, origin, destination, routing, isLoading, sum }) => {
  const StateHub = useSelector((state) => state?.Auth?.session?.hub);
  const Dispatch = useDispatch();

  const setOrigin = () => {
    if (type !== 'pickup') {
      Dispatch(Map.$setOrigin(origin));
    } else {
      if (routing.length > 0) {
        Dispatch(Map.$setOrigin(routing[0]?.origin));
      } else {
        Dispatch(Map.$setOrigin(null));
      }
    }
  };

  const setDestination = () => {
    if (type === 'console') {
      Dispatch(Map.$setDestination(destination));
      return;
    }

    if (type === 'pickup') {
      Dispatch(Map.$setDestination(destination || StateHub));
      return;
    }

    let results = [];

    if (routing) {
      routing?.forEach(async (j, i) => {
        if (type === 'pickup') {
          // first index pickup already used as origin
          if (i > 0) {
            results.push(j.origin);
          }
        } else {
          results.push(j.destination);
        }
      });
    }

    if (type === 'pickup') {
      results.push(StateHub);
    }

    if (results.length) {
      Dispatch(Map.$setDestinations(results));
    }
  };

  React.useEffect(() => {
    Dispatch(Map.$setOrigin(null));
    Dispatch(Map.$setDestination(null));

    if (!type || !routing) return;

    setTimeout(() => {
      setOrigin();
      setDestination();
    }, 1000);
  }, [type, origin, destination, JSON.stringify(routing)]);

  return isLoading ? (
    <Skeletons height="400px" />
  ) : (
    <div className="border border-bottom-0 bg-white">
      <div className="position-relative">
        <Maps centerDynamic={false} className="map-container" />
        <div className="border-top">
          <div className="row">
            <div className="col-4">
              <div className="border-end text-center p-2">
                <div className="fs-5 fw-semibold text-left text-secondary">
                  {routing?.length || 0}
                </div>
                <div className="page-pretitle text-secondary">
                  Total Shipment
                </div>
              </div>
            </div>
            <div className="col-4">
              <div className="border-end text-center p-2">
                <div className="fs-5 fw-semibold text-left text-secondary">
                  {currencyFormat(sum?.weight)}
                </div>
                <div className="page-pretitle text-secondary">
                  Total Berat (KG)
                </div>
              </div>
            </div>
            <div className="col-4">
              <div className="text-center p-2">
                <div className="fs-5 fw-semibold text-left text-secondary">
                  {currencyFormat(sum?.quantity)}
                </div>
                <div className="page-pretitle text-secondary">Total Koli</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
